import { render, staticRenderFns } from "./purchaseDetials.vue?vue&type=template&id=659b1db0&"
import script from "./purchaseDetials.vue?vue&type=script&lang=js&"
export * from "./purchaseDetials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports